export default __webpack_public_path__ + "static/media/PERCEPTO.7bd86e74.png";